import { Loading } from '@/components/Atoms/Loading/Loading';
import type { FCC } from 'react-fc';
import styled from 'styled-components';

/**
 * Wrap an area of the page that can be updated dynamically, and therefore will have a loading state.
 */
export const DynamicallyUpdatingArea: FCC<{ loading?: boolean; iconless?: boolean }> = ({
    children,
    className,
    loading = false,
    iconless = false,
}) => (
    <StyledArea className={className} $loading={loading} $iconless={iconless}>
        {children}
        {loading && !iconless && <LoadingIcon />}
    </StyledArea>
);

const StyledArea = styled.div<{ $loading?: boolean; $iconless?: boolean }>`
    ${({ $loading, $iconless }) =>
        $loading &&
        `
        position: relative;
        ${$iconless ? '> * { filter: blur(5px); }' : '> *:not(:last-child) { filter: blur(5px); }'}
    `};
`;

const LoadingIcon = styled(Loading)`
    position: absolute;
    top: var(--size-grid-double);
    left: 50%;
    transform: translateX(-50%);
`;
